import React, { useState } from 'react';
import './App.css'; // Assuming you have an App.css for styling
import Explorer from './Explorer';
import Search from './Search';
import logo from './logo.svg'; // Replace './logo.svg' with the path to your logo

function App() {
const [activeComponent, setActiveComponent] = useState('');

return (
<div className="App">
<header className="App-header">
<img src={logo} className="App-logo" alt="logo" /><img src="./seedfinderlogo700.png" className="LogoPic"  alt="logo" />
</header>
<div className="App-navi">
<button className="buttonClass" onClick={() => setActiveComponent('SEARCH')}>SEARCH</button>
<button className="buttonClass" onClick={() => setActiveComponent('EXPLORE')}>EXPLORE</button>
</div>
<main className="App-main">
{activeComponent === 'SEARCH' ? <Search /> : null}
{activeComponent === 'EXPLORE' ? <Explorer /> : null}
</main>
<footer className="App-footer"><a href="https://molecularMajik.com/">mark@molecularMajik.com</a></footer>
</div>
);
}

export default App;
